var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktopIcon = function SvgDesktopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 23,
    viewBox: "0 0 27 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.745 18.072H3.255c-.74-.001-1.451-.261-1.975-.723-.524-.462-.818-1.088-.82-1.742V2.464c.002-.653.296-1.28.82-1.741A2.998 2.998 0 0 1 3.255 0h20.49c.741 0 1.451.26 1.975.723.524.462.819 1.088.82 1.741v13.143c-.001.654-.296 1.28-.82 1.742a2.998 2.998 0 0 1-1.975.723ZM3.255 1.642a1 1 0 0 0-.658.242.777.777 0 0 0-.273.58v13.143c0 .218.098.427.273.58a1 1 0 0 0 .658.242h20.49a1 1 0 0 0 .659-.241.777.777 0 0 0 .273-.58V2.463a.777.777 0 0 0-.273-.58 1 1 0 0 0-.659-.241H3.255ZM20.95 21.357H6.05V23H20.95v-1.643Z"
  })));
};
export default SvgDesktopIcon;